
import FormPatientDetail from "pages/home/components/formPatientDetail/FormPatientDetail";
import "./styles.scss";
import useNotify from "hooks/useNotify";
import { useDispatch, useSelector } from "react-redux";
import HomeHook from "hooks/home/homeHook";
import { useEffect, useState, useTransition } from "react";
import HomeApiHook from "hooks/home/homeApiHook";
import { getGroupByFacility, getGroups, getGroups2 } from "store/master/actions";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { LeftOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import GroupHook from "hooks/group/groupHook";
import { apiGetDetailPatient, apiGetPatientFacility } from "helpers/api/master/patients";
import PatientApiHook from "hooks/patient/patientApiHook";
import PatientHook from "hooks/patient/patientHook";
import PartnerHook from "hooks/partner/partnerHook";
// import find from "local-devices";

// var postal_code = require("japan-postal-code");
const PatientDetail = () => {
  const { pageInit, pageInitAdmin, callGetPatients, callGetDevices, callGetPatientByFacility } = HomeApiHook();
  const [patientEditting, setPatientEditting] = useState({});
  const { patientList, state, usageLisences } = HomeHook();

  // const { clearMessageEnrole } = PartnerHook();
  let dispatch = useDispatch();
  const { showToastSuccess, showToastError } = useNotify();
  const { devices, groups, areas, master, diapers } = state;
  const { groupList2 } = GroupHook();

  const { clearMessageEnrole } = PatientApiHook();

  // const [facilityId, setFacilityId] = useState('');
  // const [partnerId, setPartnerId] = useState('');

  const { unlinkPatientShared } = PatientApiHook();

  const { error, success } = useSelector((state) => state.MasterReducer);
  const history = useHistory();


  useEffect(() => {

    if (error?.code !== undefined && error?.code !== 200) {
      showToastError(error.message);
      clearMessageEnrole();
    }

    console.log(success?.message, success?.type, success?.type === 'DELETE' && success?.message !== '' && success?.message !== undefined)

    if (success?.type === 'DELETE' && success?.message !== undefined) {
      showToastSuccess(success.message);

      // localStorage.setItem("IMMEDIENTLY_FILTER_INDIVIDUAL", false);
      clearMessageEnrole();

      history.goBack();
    }
  }, [error, success]);




  useEffect(() => {
    clearMessageEnrole();

    const paramFilter = localStorage.getItem("PATIENT_PARAM_ADMIN2");

    const data = JSON.parse(paramFilter)

    dispatch(getGroups2({ facility_id: data?.facility_id, partner_id: data?.partner_id }));

    const id = window.location.pathname.split('/')[2];

    apiGetDetailPatient(id)
      .then((res) => {
        if (res) {
          setPatientEditting(res.data)
        }
      })
      .catch(() => {
        // Patient đã bị xóa / không tồn tại → BE trả 404. Báo và quay về danh sách
        // thay vì để promise rejection gây "Uncaught runtime errors".
        showToastError(t('no_matching_data'));
        history.replace('/');
      })
    pageInitAdmin();
  }, [])

  const { t } = useTranslation();
  return (
    <div className="detail-container">
      <div className="detail-header">
        <a onClick={history.goBack}>
          <LeftOutlined />
          <span className="detail-header-back">{t('button.back')}</span>
        </a>
      </div>
      <div className="detail-content">
        <FormPatientDetail
          setShowModalUpdatePatient={true}
          areas={areas}
          devices={devices}
          master={master}
          groups={groupList2}
          diapers={diapers}
          patientEditting={patientEditting}
          onUnlinkPatient={unlinkPatientShared}
          setPatientEditting={setPatientEditting}
        />
      </div>
    </div>

  )
};
export default PatientDetail;
